module.exports = __webpack_public_path__ + "img/icon-error-filled.9b239111.svg";